import React from 'react';

import {copyComponentKeys} from './higher-order-components';
import {oeInterfaceManager} from '../../react-oe/oe-interface';
import {UILevel} from '../oe-types';

// translates the given object (obj) to the specified ui level
export function translateToUILevel(obj, uiLevel)    {
    if(!uiLevel || uiLevel === UILevel.std)  return obj;

    if(obj[uiLevel]) return {...obj, ...obj[uiLevel]};
        
    var res = {};
    Object.keys(obj).forEach(key => {
        const v = obj[key];
        res[key] = typeof(v) === 'object' && v !== null && v.hasOwnProperty(uiLevel) ? v[uiLevel] : v;
    });
    return res;
}

// translates the props of the component with respect to the provides uiLevel
export function withUILevel(WrappedComponent) {
    return copyComponentKeys(class extends React.PureComponent {

        render() {
            const uiLevel = this.props.uiLevel || UILevel.std;
            const props = translateToUILevel(this.props, uiLevel);
            return <WrappedComponent {...props}/>;
        }

    }, WrappedComponent);
}

// provides ui level as prop from core module
export function addUILevelProp(WrappedComponent) {
    return copyComponentKeys(class extends React.PureComponent {

        constructor(props) {
            super(props);

            this.mounted = false;
            this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

            this.state = {
                uiLevel: UILevel.std
            };

            this.onConnect = this.onConnect.bind(this);
            this.onRelease = this.onRelease.bind(this);

            this.updateUILevel = this.updateUILevel.bind(this);
        }

        componentWillReceiveProps(nextProps) {
            if(this.mounted && nextProps.moduleId !== this.props.moduleId)     {
                this.release(); 
                this.connect(nextProps.moduleId);
            }
        }
    
        componentDidMount()    {
            this.mounted = true;
            this.connect();
        }
    
        componentWillUnmount()    {
            this.release();
            this.mounted = false;
        }
    
        connect(moduleId) {
            this.oe = oeInterfaceManager.getInterface(moduleId || this.props.moduleId);
            this.oe.register(this.onConnect, this.onRelease);
            if(this.oe.isReady() && this.oe.isOnConnectCalled())   this.onConnect();
        }
    
        release()   {
            this.oe.unregister(this.onConnect, this.onRelease);
            if(this.oe.isReady())   {
                this.onRelease();
            } else {
                this.updateState();
            }   
        }
    
        onConnect()  {
            this.updateState();
            this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiLevelChanged, this.updateUILevel);
        }
    
        onRelease()    {
            this.updateState(true);
            this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiLevelChanged, this.updateUILevel);
        }

        updateUILevel() {
            this.setState({
                uiLevel: UILevel.levelFromModuleValue(this.oe.sharedInterface.getUIControllerSettings().getUILevel().value)
            });
        }
    
        updateState(released)   {
            if(!this.oe.isReady() || released === true) {
                //this.setState({ uiLevel: UILevel.std });  // do not switch back at disconnect, instead wait for new state when connecting
                return;
            }
    
            this.updateUILevel();
        }

        render() {
            return <WrappedComponent uiLevel={this.state.uiLevel} {...this.props} />;
        }

    }, WrappedComponent);
}

export function withAddedUILevel(WrappedComponent) {
    return addUILevelProp(withUILevel(WrappedComponent));
}

